// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"kn-z","badgeLink":"ln-z","category":"mn-z"};